<template>
  <v-container id="noticias" tag="section">
    <base-v-component heading="Noticias del negocio" />
    <base-material-card
      color="indigo"
      icon="mdi-newspaper-variant"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn color="success" dark class="mb-2" @click="goAdd()"
          >Crear Nueva</v-btn
        >

        <v-btn
          v-if="!ordenando"
          color="success"
          dark
          class="mb-2 mx-2"
          @click="ordenando = true"
          >Ordenar</v-btn
        >
        <v-btn
          v-if="ordenando"
          color="success"
          dark
          class="mb-2 mx-2"
          @click="ordenando = false"
          >Volver Listado</v-btn
        >
        <v-spacer />
        <v-text-field
          v-if="!ordenando"
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="noticias"
        :loading="loading"
        :search="search"
        sort-by="orden"
        v-if="!ordenando"
      >
        <template v-slot:item.acciones="{ item }">
          <v-card-actions class="pa-0 ma-0">
            <v-spacer></v-spacer>
            <v-tooltip top v-if="item.activo">
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="cambiarActivo(item)"
                  :loading="loadingActivo"
                  class="px-2 ml-1"
                  color="green"
                  min-width="0"
                  v-on="on"
                  small
                >
                  <v-icon small>mdi-check</v-icon>
                </v-btn>
              </template>
              <span>Desactivar</span>
            </v-tooltip>
            <v-tooltip top v-else>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="cambiarActivo(item)"
                  v-on="on"
                  class="px-2 ml-1"
                  :loading="loadingActivo"
                  color="red"
                  min-width="0"
                  small
                >
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Activar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="goEdit(item)"
                  v-on="on"
                  class="px-2 ml-1"
                  color="grey"
                  min-width="0"
                  small
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <!-- <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="verRespuestas(item)"
                  v-on="on"
                  class="px-2 ml-1"
                  color="info"
                  min-width="0"
                  small
                >
                  <v-icon small>mdi-book</v-icon>
                </v-btn>
              </template>
              <span>Ver respuestas</span>
            </v-tooltip> -->
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="deleteItem(item)"
                  :loading="loadingBorrar"
                  v-on="on"
                  class="px-2 ml-1"
                  color="red"
                  min-width="0"
                  small
                >
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Borrar noticia</span>
            </v-tooltip>
          </v-card-actions>
        </template>
      </v-data-table>
      <v-row v-else align="center" justify="center">
        <v-col cols="6">
          <v-list>
            <draggable v-model="ordenC">
              <div v-for="element in noticiasOrden" :key="element.id">
                <v-list-item>
                  <v-list-item-avatar>
                    <v-icon big>mdi-drag</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>{{
                    element.titulo
                  }}</v-list-item-content>
                  <v-list-item-action>{{ element.orden }}</v-list-item-action>
                </v-list-item>
              </div>
            </draggable>
          </v-list>
        </v-col>
      </v-row>
    </base-material-card>
  </v-container>
</template>

<script>
import { mostrarIdioma } from "@/utils/utils.js";
import { mapState, mapGetters, mapActions } from "vuex";
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
  },
  data() {
    return {
      search: "",
      ordenando: false,
      loading: false,
      loadingForm: false,
      loadingActivo: false,
      loadingBorrar: false,
      headers: [
        {
          sortable: false,
          text: "Título",
          value: "titulo",
          width: "80%",
        },
        {
          sortable: false,
          text: "Orden",
          value: "orden",
          width: "10%",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          width: "10%",
          align: "right",
        },
      ],
    };
  },
  computed: {
    noticiasOrden(state) {
      let objs = this.noticias;
      return objs.sort((a, b) =>
        a.orden > b.orden ? 1 : b.orden > a.orden ? -1 : 0
      );
    },
    ordenC: {
      get() {
        return this.noticiasOrden;
      },
      set(v) {
        var res = [];
        let _vm = this;
        v.forEach((e, i) => {
          let aux = {
            orden: i,
            id: e.id,
          };
          res.push(aux);
        });
        return this.$store
          .dispatch("noticias/ordenarNoticias", res)
          .then(() => {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Noticias ordenadas",
            });
            _vm.reload();
          })
          .catch((e) => {
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al ordenar noticias",
            });
          });
      },
    },
    ...mapState({
      idiomas: "idiomas",
      langDefecto: "langDefecto",
      noticiasState: (state) => state.noticias.noticias,
    }),
    ...mapGetters({
      negocio: "app/negocioGestObj",
      role: "auth/role",
    }),
    noticias() {
      return this.noticiasState.map((n) => {
        return {
          id: n.id,
          activo: n.activo ? n.activo : false,
          orden: n.orden ? n.orden : 0,
          titulo: n.titulo ? n.titulo : "sin datos",
        };
      });
    },
  },
  watch: {},
  methods: {
    cambiarActivo(item) {
      var _vm = this;
      _vm.loadingActivo = true;
      this.$store
        .dispatch("noticias/changeActivo", {
          id: item.id,
          activo: !(item.activo ? item.activo : false),
        })
        .then((res) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Noticia grabada con éxito",
          });
          return _vm.reload();
          _vm.dialog = false;
        })
        .catch((error) => {
          console.log(error);
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar la noticia",
          });
        })
        .finally(() => {
          _vm.loadingActivo = false;
        });
    },
    mostrarIdioma(str) {
      return mostrarIdioma(str);
    },
    reload() {
      return this.$store.dispatch("noticias/getNoticias");
    },
    goAdd() {
      var str;
      switch (this.role) {
        case "boss_negocio":
          str = "/admin/negocio/noticias/form";
          break;
        case "admin":
          str = "/admin/gest/" + this.negocio.id + "/noticias/form";
          break;
      }
      this.$router.push(str);
    },
    goEdit(item) {
      var str;
      switch (this.role) {
        case "boss_negocio":
          str = "/admin/negocio/noticias/form/" + item.id;
          break;
        case "admin":
          str = "/admin/gest/" + this.negocio.id + "/noticias/form/" + item.id;
          break;
      }
      this.$router.push(str);
    },
    verRespuestas(item) {
      let str = "/admin/negocio/noticias/respuestas/" + item.id;
      this.$router.push(str);
    },
    deleteItem(item) {
      var _vm = this;

      this.$confirm(
        "¿Desea eliminar esta noticia? Esta acción es irreversible?",
        {
          buttonTrueText: "Aceptar",
          buttonFalseText: "No",
          color: "warning",
          icon: "warning",
          width: 350,
        }
      ).then((res) => {
        if (res) {
          _vm.loadingBorrar = true;
          return this.$store
            .dispatch("noticias/deleteNoticia", {
              id: item.id,
              activo: !(item.activo ? item.activo : false),
            })
            .then((res) => {
              _vm.$store.commit("snackbar/setMensajeSuccess", {
                msj: "Noticia borrada con éxito",
              });
              return _vm.reload();
              _vm.dialog = false;
            })
            .catch((error) => {
              console.log(error);
              _vm.$store.commit("snackbar/setMensajeDanger", {
                msj: "Error al borrar la noticia " + error,
              });
            })
            .finally(() => {
              _vm.loadingBorrar = false;
            });
        }
      });
    },
  },
  mounted() {
    this.reload();
  },
};
</script>
